export const extractDataTypes = {
  NONE: 'None',
  split: 'Split and Extract on Delimiter',
} as const
